import { PaginatedRequestParams } from 'api';

export enum RatingFilterFormField {
  ratingtypeid = 'FacilityId',
}
export type RatingFilterFormValues = {
  [RatingFilterFormField.ratingtypeid]: string | undefined;
};

export type RatingFilterFormPaginated = RatingFilterFormValues &
  PaginatedRequestParams;
